export const mockData = {
  company: {
    name: 'A to Z Home Solutions',
    tagline: 'Complete Home Solutions, From Vision to Reality',
    phone: '9989191565',
    phone2: '8328185409',
    email: 'info@atozhomesolutions2024.com',
    address: '#6-2-817-1, Ground Floor, Near Venkateshwaraswamy temple, Ram Nagar, Anantapur-515001',
    established: 'January 2024',
    logo: 'https://customer-assets.emergentagent.com/job_home-solutions-ai/artifacts/gdqxm32q_IMG-20260124-WA0039.jpg',
    coverPhoto: 'https://customer-assets.emergentagent.com/job_home-solutions-ai/artifacts/dyokozfr_IMG-20241216-WA0017.jpg',
    serviceLocations: ['Anantapur', 'Bangalore', 'Hyderabad'],
    social: {
      instagram: 'https://www.instagram.com/atozhomesolutions2024?igsh=MTd2ZzZkN3VqcnduaQ%3D%3D&utm_source=qr',
      youtube: 'https://youtube.com/@atozhomesolutions2024?si=y5gYBenCMdTWC5Y2'
    }
  },
  
  services: [
    {
      id: 1,
      title: 'Interior Design',
      description: 'Transform your space with our expert interior design services. From concept to completion, we create beautiful, functional spaces.',
      icon: 'Palette'
    },
    {
      id: 2,
      title: 'Complete Construction',
      description: 'Full-scale construction services for residential and commercial projects. Quality craftsmanship guaranteed.',
      icon: 'HardHat'
    },
    {
      id: 3,
      title: 'Renovation & Remodeling',
      description: 'Breathe new life into your existing space. We handle everything from minor updates to major renovations.',
      icon: 'Hammer'
    },
    {
      id: 4,
      title: 'Maintenance Services',
      description: 'Keep your property in top condition with our comprehensive maintenance and repair services.',
      icon: 'Wrench'
    }
  ],
  
  projects: [
    {
      id: 1,
      title: 'Modern Interior Design',
      category: 'Interior Design',
      type: 'image',
      media: 'https://customer-assets.emergentagent.com/job_home-solutions-ai/artifacts/5q3perva_IMG-20251108-WA0059.jpg'
    },
    {
      id: 2,
      title: 'Contemporary Living Space',
      category: 'Interior Design',
      type: 'image',
      media: 'https://customer-assets.emergentagent.com/job_home-solutions-ai/artifacts/o46ceqhx_IMG-20251108-WA0066.jpg'
    },
    {
      id: 3,
      title: 'Elegant Home Interior',
      category: 'Interior Design',
      type: 'image',
      media: 'https://customer-assets.emergentagent.com/job_home-solutions-ai/artifacts/1k5pm547_IMG-20251108-WA0061.jpg'
    },
    {
      id: 4,
      title: 'Luxury Interior Setup',
      category: 'Interior Design',
      type: 'image',
      media: 'https://customer-assets.emergentagent.com/job_home-solutions-ai/artifacts/6h0xdhnl_IMG-20251108-WA0055.jpg'
    },
    {
      id: 5,
      title: 'Premium Home Design',
      category: 'Interior Design',
      type: 'image',
      media: 'https://customer-assets.emergentagent.com/job_home-solutions-ai/artifacts/j53yxhil_IMG-20251108-WA0057.jpg'
    },
    {
      id: 6,
      title: 'Custom Interior Project',
      category: 'Interior Design',
      type: 'image',
      media: 'https://customer-assets.emergentagent.com/job_home-solutions-ai/artifacts/0ysrvu7w_IMG-20251108-WA0025.jpg'
    },
    {
      id: 7,
      title: 'Stylish Home Interior',
      category: 'Interior Design',
      type: 'image',
      media: 'https://customer-assets.emergentagent.com/job_home-solutions-ai/artifacts/5yeair9u_IMG-20251108-WA0027.jpg'
    },
    {
      id: 8,
      title: 'Modern Living Design',
      category: 'Interior Design',
      type: 'image',
      media: 'https://customer-assets.emergentagent.com/job_home-solutions-ai/artifacts/gmcv30jb_IMG-20251108-WA0015.jpg'
    },
    {
      id: 9,
      title: 'Elegant Interior Space',
      category: 'Interior Design',
      type: 'image',
      media: 'https://customer-assets.emergentagent.com/job_home-solutions-ai/artifacts/il7nokdi_IMG-20251108-WA0057.jpg'
    },
    {
      id: 10,
      title: 'Premium Home Interior',
      category: 'Interior Design',
      type: 'image',
      media: 'https://customer-assets.emergentagent.com/job_home-solutions-ai/artifacts/6icg0f5g_IMG-20251108-WA0055.jpg'
    },
    {
      id: 11,
      title: 'Interior Design Project',
      category: 'Interior Design',
      type: 'video',
      media: 'https://customer-assets.emergentagent.com/job_home-solutions-ai/artifacts/fasy05fd_VID-20251028-WA0011.mp4'
    },
    {
      id: 12,
      title: 'Home Renovation Work',
      category: 'Interior Design',
      type: 'video',
      media: 'https://customer-assets.emergentagent.com/job_home-solutions-ai/artifacts/o2apin8t_VID-20251214-WA0028.mp4'
    },
    {
      id: 13,
      title: 'Interior Transformation',
      category: 'Interior Design',
      type: 'video',
      media: 'https://customer-assets.emergentagent.com/job_home-solutions-ai/artifacts/wwodok4f_VID-20251027-WA0016.mp4'
    },
    {
      id: 14,
      title: 'Complete Home Makeover',
      category: 'Interior Design',
      type: 'video',
      media: 'https://customer-assets.emergentagent.com/job_home-solutions-ai/artifacts/b47f7qyy_VID-20251214-WA0030.mp4'
    },
    {
      id: 15,
      title: 'Design Excellence',
      category: 'Interior Design',
      type: 'video',
      media: 'https://customer-assets.emergentagent.com/job_home-solutions-ai/artifacts/nkhvlk0u_VID-20250104-WA0041.mp4'
    }
  ],
  
  founders: [
    {
      id: 1,
      name: 'Dadithota Sudhakar Reddy',
      role: 'Founder & Managing Partner',
      image: 'https://customer-assets.emergentagent.com/job_home-solutions-ai/artifacts/7mq7qpi3_IMG_0938.jpeg',
      headline: 'From Dadithota to Designing Dreams',
      quote: '"I believe a home is more than just four walls; it\'s a reflection of one\'s journey and aspirations."',
      bio: 'For Sudhakar Reddy, the path to founding A to Z Home Solutions is a story of growth, grit, and a deep-rooted commitment to quality. Raised in the small village of Dadithota in the Anantapur District of Andhra Pradesh, Sudhakar\'s humble beginnings are the heartbeat of his business today.\n\nWith a diverse professional career spanning more than 15 years, Sudhakar spent over a decade mastering various business domains before dedicating the last four years to his true passion: Interior Design. This unique combination of multi-industry expertise and specialized design knowledge allows him to lead A to Z Home Solutions with a rare blend of creative vision and disciplined project management.\n\nSudhakar\'s philosophy is built on the "humble hustle"—the belief that every client deserves premium, honest, and innovative design solutions, regardless of the project\'s scale. He understands the value of hard work and ensures that for every homeowner, the journey from "A to Z" is handled with transparency, precision, and care.'
    },
    {
      id: 2,
      name: 'Bana Srikanth Reddy',
      role: 'Co-founder & CEO',
      image: 'https://customer-assets.emergentagent.com/job_home-solutions-ai/artifacts/3gyznvid_ae690d45-462b-4797-8940-443af8eeeb11.jpeg',
      headline: 'Engineering Beautiful Spaces',
      bio: 'For Bana Srikanth Reddy, interior design is where logic meets creativity. After completing his B.Tech and gaining valuable experience in the software sector, Srikanth decided to pivot from coding digital spaces to designing physical ones.\n\nDriven by a dream to build a premier interior firm, he co-founded A to Z Home Solutions. Srikanth believes that a well-designed home requires the same attention to detail as a complex piece of software—it must be functional, efficient, and user-friendly. By leading the team on the ground, he ensures that the company\'s vision is executed flawlessly, bridging the gap between technical planning and aesthetic beauty.'
    }
  ],
  
  testimonials: [
    {
      id: 1,
      name: 'Sarah Johnson',
      role: 'Homeowner',
      content: 'A to Z Home Solutions transformed our house into our dream home. Their attention to detail and professionalism was outstanding!',
      rating: 5
    },
    {
      id: 2,
      name: 'Michael Chen',
      role: 'Business Owner',
      content: 'Excellent construction work on our commercial space. Completed on time and within budget. Highly recommend!',
      rating: 5
    },
    {
      id: 3,
      name: 'Emily Rodriguez',
      role: 'Property Developer',
      content: 'Professional team with great expertise. They handled our renovation project flawlessly from start to finish.',
      rating: 5
    }
  ],
  
  chatbotResponses: {
    greeting: 'Hello! Welcome to A to Z Home Solutions. How can I help you today?',
    services: 'We offer Interior Design, Complete Construction, Renovation & Remodeling, and Maintenance Services. Which service interests you?',
    contact: 'You can reach us at +1 (555) 123-4567 or email us at info@atozhomesolutions.com',
    quote: 'I\'d be happy to help you get a quote! Please fill out our consultation form and our team will contact you within 24 hours.'
  }
};